export default __webpack_public_path__ + "static/media/magnifier-plus.5d312c2a.svg";